import { FormattedMessage } from 'react-intl';
import { Chip } from 'components/ui';

const Boolean = ({
  value,
  falseLabel = <FormattedMessage id="boolean.no" />,
  trueLabel = <FormattedMessage id="boolean.yes" />,
}) => {
  if (value) {
    return <Chip label={trueLabel} color="primary" />;
  } else {
    return <Chip label={falseLabel} color="warning" />;
  }
};

export default Boolean;
